// Lighter subaccount-key onboarding: the backend mints a fresh ECgFp5
// keypair server-side, builds and self-signs the ChangePubKey tx with it,
// and hands back only a human-readable text string
// (LighterPrepareSubaccountKeyResponse.personalSignText, e.g. "Register
// Lighter Account\n...") for the customer's wallet to authorize. This is
// plain `personal_sign` over that text — NOT EIP-712 typed data (unlike
// Hyperliquid's approveAgent). `personal_sign` takes its message as a hex
// string, and this one is plain UTF-8 text, so it has to be hex-encoded
// first or wallets sign the wrong bytes.
import { stringToHex } from 'viem'

import { assertManualWalletAction, getWalletProvider } from '@/lib/wallet/connect'

export async function signPersonalSignText(params: {
  walletAddress: string
  personalSignText: string
}): Promise<string> {
  assertManualWalletAction()
  const { walletAddress, personalSignText } = params
  const provider = await getWalletProvider()
  const signature = await provider.request({
    method: 'personal_sign',
    params: [stringToHex(personalSignText), walletAddress as `0x${string}`],
  })
  return signature as string
}

// personal_sign carries no chain id, so unlike the Hyperliquid signer this
// re-exports only the connection helpers.
export { beginManualWalletAction, connectWallet, getConnectedAddress } from '@/lib/wallet/connect'
